import React from "react";
import { toast } from "react-toastify";
import { Input, Select } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreatePriceRule } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { useProducts } from "../../products/hooks";

interface IProps {
  productId?: number;
  customerId?: number;
  onCompleted: () => void;
}

export const PriceRuleForm: React.FC<IProps> = ({ productId, customerId, onCompleted }) => {
  const { data: productsData } = useProducts({ where: {}, limit: 100, offset: 0 });
  const { form, submit, loading } = useCreatePriceRule({
    defaultValues: { productId, customerId, quantity: 1 },
    onCompleted: () => {
      toast.success("La règle de prix a été créée avec succès");
      form.reset({ productId, customerId, quantity: 1 });
      onCompleted();
    },
  });

  return (
    <div className="flex flex-wrap gap-3 items-end">
      {!productId && (
        <Select
          label="Produit"
          className="w-full"
          {...form.register("productId", { required: true, valueAsNumber: true })}
        >
          <option value="">-</option>
          {productsData?.products?.results?.map((product) => (
            <option key={product.id} value={product.id}>
              {product.name}
            </option>
          ))}
        </Select>
      )}
      {!customerId && <CustomerSelectSearch form={form} name="customerId" label="Client (optionnel)" />}
      <Input
        label="Quantité minimale"
        type="number"
        className="w-full"
        {...form.register("quantity", { required: true, valueAsNumber: true })}
        placeholder="1"
      />
      <Input
        label="Prix (centimes)"
        type="number"
        className="w-full"
        {...form.register("priceCents", { required: true, valueAsNumber: true })}
      />
      <Button onClick={submit} loading={loading} disabled={loading}>
        Ajouter la règle
      </Button>
    </div>
  );
};
